import { Box, Flex, Link, Text, VStack } from "@chakra-ui/react";
import { DateTime } from "luxon";
import { useEffect, useState } from "react";
import DashboardService from "../services/api";

export const Employee = () => {
  const localData =
    localStorage.getItem("userdata") || JSON.stringify({ accessCode: "" });
  const access_code = JSON.parse(localData).accessCode;
  const [data, setData] = useState<any>([]);
  const formatDate = (dateString: string) => {
    if(!dateString) return ""
    const date = DateTime.fromFormat(dateString, "M/d/yyyy");
    return date.toFormat("dd-LLL-yy (ccc)");
  };
  const fetchData = async () => {
    DashboardService.getEmployeesDetails(access_code)
      .then((res: any) => {
        const response = res.data;
       setData(sortBookingsBySessionTime(response));
      //  console.log(sortBookingsBySessionTime(response));
      })
      .catch((e) => {
        console.log(e);
      });
  };
  function sortBookingsBySessionTime(bookings: any[]) {
    return bookings.sort((a, b) => {
      if (a.session_time === "" && b.session_time === "") return 0;
      if (a.session_time === "") return 1;
      if (b.session_time === "") return -1;

      const parseTime = (time: any) => {
        const [hours, minutes] = time.match(/(\d+):(\d+)/).slice(1, 3);
        const isPM = time.includes("PM");
        const adjustedHours =
          isPM && hours !== "12" ? parseInt(hours) + 12 : parseInt(hours) % 12;
        return new Date(0, 0, 0, adjustedHours, parseInt(minutes));
      };

      const timeA: any = parseTime(a.session_time);
      const timeB: any = parseTime(b.session_time);

      return timeA - timeB;
    });
  }

  const convertTo12HourFormat:any = (time24:string) => {
    
    const [hours, minutes] = time24.split(":").map(Number);

    const dateTime = DateTime.fromObject({ hour: hours, minute: minutes });

    return dateTime.toFormat("h:mm a");
  };

  useEffect(() => {
    fetchData();
  }, []);
  return (
    <div>
      <h1 style={{ padding: "25px", backgroundColor: "#fff" }}>
        Employees Bookings
      </h1>
      {data.length === 0 ? (
        <Flex justifyContent="center" alignItems="center" height="50vh">
          <Text fontSize="xx-large" color="gray.500">
            No Bookings available.
          </Text>
        </Flex>
      ) : (
        <VStack spacing={4} padding="15px">
          {/* Fixed Heading */}
          <Flex
            width="90%"
            justifyContent="space-between"
            alignItems="center"
            padding="15px"
            border="2px solid gray"
            fontWeight="bold"
            backgroundColor="gray"
            borderRadius="12px"
            color="white"
            mb="25px"
          >
            <Text width="15%">S No.</Text>
            <Text width="20%" textAlign="center">
              Booking Date
            </Text>
            <Text width="20%" textAlign="center">
              Booking Time
            </Text>
            <Text width="30%" textAlign="center">
              Upcoming/Session Date
            </Text>
            <Text width="20%" textAlign="center">
              Name
            </Text>
            <Text width="20%" textAlign="center">
              Expert Name
            </Text>
            <Text width="20%" textAlign="center">
              Original Price
            </Text>
            <Text width="20%" textAlign="center">
              Discounted Price
            </Text>
          </Flex>

          {/* Dynamic Data */}
          {data.map((session: any, index: number) => {
            return (
              <Box
                key={session._id}
                width="90%"
                borderRadius="25px"
                padding="25px"
                backgroundColor="#fff"
                mb={"15px"}
              >
                <Flex justifyContent="space-between" alignItems="center">
                  <Flex alignItems="center" width="15%" justifyContent="left">
                    <Text>{index + 1}</Text>
                  </Flex>
                  <Flex alignItems="center" width="20%" justifyContent="center">
                    <Text>{formatDate(session.booking_date)}</Text>
                  </Flex>
                  <Text width="20%" textAlign="center">
                    {session.booking_time?convertTo12HourFormat(session.booking_time):""}
                  </Text>
                  <Flex alignItems="center" width="30%" justifyContent="center">
                    <Text>
                      {session.session_time
                        ? formatDate(session.session_date)
                        : "Upcoming"}{""}
                    </Text>
                  </Flex>
                  <Flex alignItems="center" width="30%" justifyContent="center">
                    <Text>{session.lead_information.first_name} </Text>
                  </Flex>
                  <Flex alignItems="center" width="20%" justifyContent="center">
                    <Text>{session.expert_information.full_name} </Text>
                  </Flex>
                  <Flex alignItems="center" width="20%" justifyContent="center">
                    <Text>{session.cart_information.original_price} </Text>
                  </Flex>
                  <Flex alignItems="center" width="20%" justifyContent="center">
                    <Text>{session.cart_information.final_price} </Text>
                  </Flex>
                </Flex>
              </Box>
            );
          })}
        </VStack>
      )}
    </div>
  );
};
